import omit from 'lodash.omit'
import { PRESET_DOCS_SCHEMA, PRESET_SHOPIFY_SCHEMA } from './const'
import { type Project, defaultConfig as defaultConfigBase } from './const/config'

export type { RegisterSearchBoxParams as RegisterSearchBoxProps } from './SearchBox'
export type { RegisterSearchButtonParams as RegisterSearchButtonProps } from './SearchButton'

export { RegisterSearchAllResults, SearchAllResults } from './SearchAllResults'
export { RegisterSearchBox, SearchBox } from './SearchBox'
export { RegisterSearchButton, SearchButton } from './SearchButton'

export const defaultConfig: Project = omit(defaultConfigBase, ['cloudConfig'])

export const presets = {
  docs: {
    name: 'docs',
    schema: PRESET_DOCS_SCHEMA
  },
  shopify: {
    name: 'shopify',
    schema: PRESET_SHOPIFY_SCHEMA
  }
}
